// ./context/popupContext.js
import React, { createContext, useEffect, useState } from "react";
import Modal from "../components/Popup/Modal";
import Button from "@mui/material/Button";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

export const PopupContext = createContext();

export const PopupProvider = ({ children }) => {
    const [popupQueue, setPopupQueue] = useState([]);
    const [currentPopupIndex, setCurrentPopupIndex] = useState(0);
    const [isPopupOpen, setIsPopupOpen] = useState(false);

    const showPopup = (message, action) => {
        setPopupQueue((prev) => [
            ...prev,
            {message, action},
        ]);
    };

    // NEW FUNCTION: open a specific popup by index
    const openPopupAtIndex = (index) => {
        if(index >= 0 && index < popupQueue.length && popupQueue[index].action) {
            popupQueue[index].action();
        }
        else if (index >= 0 && index < popupQueue.length) {
            setCurrentPopupIndex(index);
            setIsPopupOpen(true);
        }
    };

    useEffect(() => {
        if (popupQueue.length > 0) {
            setCurrentPopupIndex(popupQueue.length - 1);
        }
    }, [popupQueue]);

    const nextPopup = () => {
        if (currentPopupIndex < popupQueue.length - 1) {
            setCurrentPopupIndex(currentPopupIndex + 1);
        }
    };

    const prevPopup = () => {
        if (currentPopupIndex > 0) {
            setCurrentPopupIndex(currentPopupIndex - 1);
        }
    };

    const closePopup = () => {
        setIsPopupOpen(false);
    };

    return (
        <PopupContext.Provider
            value={{
                showPopup,
                closePopup,
                nextPopup,
                prevPopup,
                popupQueue,
                openPopupAtIndex, // make this available
            }}
        >
            {children}
            {isPopupOpen && (
                <Modal isOpen={isPopupOpen} onClose={closePopup}>
                    <div style={{ textAlign: "center" }}>
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                color: "#f44336",
                                marginBottom: "1rem",
                            }}
                        >
                            <ErrorOutlineIcon style={{ marginRight: "0.5rem", fontSize: "2rem" }} />
                            <h3 style={{ margin: 0 }}>Warning</h3>
                        </div>
                        <p>{popupQueue[currentPopupIndex]}</p>
                        <div style={{ display: "flex", justifyContent: "space-between", marginTop: "1rem" }}>
                            <Button variant="outlined" onClick={prevPopup} disabled={currentPopupIndex === 0}>
                                ← Previous
                            </Button>
                            <Button
                                variant="outlined"
                                onClick={nextPopup}
                                disabled={currentPopupIndex >= popupQueue.length - 1}
                            >
                                Next →
                            </Button>
                        </div>
                    </div>
                </Modal>
            )}
        </PopupContext.Provider>
    );
};
